export default {
  //获取table 列表
  getBankRecList: "/bankRec/bankReconciliation/show",
  //  Unrec Trans 弹窗左边表格数据
  getClearedTransaction: "/bankRec/bankReconciliation/clearedTransaction",
  //   Unrec Trans 弹窗右边表格数据
  getBankTransaction: "/bankRec/bankReconciliation/bankTransaction",
  //  对比Clear 接口
  getReconcileTransaction: "/bankRec/bankReconciliation/reconcileTransaction",
  // BAI Sweep 数据接口
  getBaiSWeepList: "/bankRec/bankReconciliation/baisWeep",
  // BAI Sweep Clear Trans
  getBaiSweepByClearTrans: "/bankRec/bankReconciliation/baisWeepClearTrans",
  //   获取Trans 弹窗的数据
  getClearedTrans: "/bankRec/bankReconciliation/viewReconciledTrans",
  // Trans Clear 按钮
  getUnreconcileTrans: "/bankRec/bankReconciliation/unreconcileTrans",
  // 锁定bank用户
  getLockBankRec: "/bankRec/bankReconciliation/lockBankRec",
  // 解锁bank用户
  getLockBankRecDelete: "/bankRec/bankReconciliation/lockBankRecDelete",
  // Transactions 上传
  getUploadTransacions: "/bankRec/bankReconciliation/bankTransUpload",
  // Balance 上传 
  getBalanceUpload:"/bankRec/bankReconciliation/bankBalanceUpload",
  // Bai 上传
  getBaiUpload:"/bankRec/bankReconciliation/upload-bai",
// 修改balance 
  getUpdateBalanceRec:"/bankRec/bankReconciliation/updateBalance",
    // 查看未对账现金列表数据
  getShowUnreconciled:"/bankRec/bankReconciliation/showBankUnreconciledRecord",
  // 查看Book未对账现金列表
  getShowBookUnreceived:"/bankRec/bankReconciliation/showBookUnreconciledRecord",
  // bankTrans 选择propId自动对账
  getBankTransByProp:"/bankRec/bankReconciliation/reconcileWireTransfer",
  // 查询账户是否被锁
  getBankByLock:"/bankRec/bankReconciliation/bankLock",
  // recordFundTransfer 跳转查询
//  getRecordFundTransfer:"/bankRec/bankReconciliation/recordFundTransfer",
    getRecordFundTransfer:"/bankRec/bankReconciliation/showBankTransactionRecords",
  // RecordFund by prop  自动对账
  getRecordFundTransferByProp:"/bankRec/bankReconciliation/fundTransfer",
  //  bank trust 下拉框查询
  getBankRecByTrust:"/bankRec/bankReconciliation/trustNameOptions",
  // bank name 下拉框查询
  getBankRecByBankName:"/bankRec/bankReconciliation/bankNameOptions",
  // 查看手动自动对账列表Book数据
  getReconciledTransByType:"/bankRec/bankReconciliation/viewReconciledTransByType",
  //获取bai code 下拉框数据
  getBaiCodeDict:"/bankRec/bankReconciliation/baiCodeOptions",
  // 批量 clear 
  getBatchFundTransfer:"/bankRec/bankReconciliation/batchFundTransfer",
  // recordCredit 单个操作
  getRecordCredit:"/bankRec/bankReconciliation/recordCredit",
  // recordCredit 批量操作
  getBatchRecordCredit:"/bankRec/bankReconciliation/batchRecordCredit",
  // recordDebit 单个操作
  getRecordDebit:"/bankRec/bankReconciliation/recordDebit",
  // recordDebit 多个操作
  getBatchRecordDebit:"/bankRec/bankReconciliation/batchRecordDebit",
  // credit 获取GlAcct
  getCreditGIAcct:"/bankRec/bankReconciliation/creditGlAcct",
  // debitGLAcct
   getDebitGIAcct:"/bankRec/bankReconciliation/debitGlAcct",
  //  进行取消手动自动对账功能
  getBatchUnreconciledTrans:"/bankRec/bankReconciliation/batchUnreconcileTrans",
  // OutstandingTransactionsReport 
  getOutstandingTransactions:"/bankRec/bankReconciliation/showOutstandingTransactionsReport"
};
